import { useSelector } from "react-redux";
import { CartoLayer } from "@deck.gl/carto";
import { selectSourceById } from "@carto/react-redux";
import { useCartoLayerProps } from "@carto/react-api";
//import parseOriginTable from "data/sources/parseOriginTable";

export const VISITORS_DESTINATION_LAYER_ID = "visitorsDestinationLayer";

export default function VisitorsDestinationLayer() {
  const { visitorsDestinationLayer } = useSelector(
    (state) => state.carto.layers
  );
  const source = useSelector((state) =>
    selectSourceById(state, visitorsDestinationLayer?.source)
  );
  //const visitorsOrigin = useSelector((state) => state.app.visitorsOrigin);
  const cartoLayerProps = useCartoLayerProps({
    source: source,
  });
  if (source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: VISITORS_DESTINATION_LAYER_ID,
      visible: visitorsDestinationLayer.visible,
      getFillColor: [0, 0, 0, 0],
      lineWidthUnits: "pixels",
      getLineColor: [71, 219, 153],
      getLineWidth: 2,
      pickable: false,
    });
  }
}
